// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"532":"5801c307a73d66a38214","691":"cac59312fa9624de029c"}[chunkId] + ".js";
};